/*
 * 在页面上展示下单步骤的模板
 * 但对话框展示下单步骤的形式看起来不是很用户友好，窗口太小看不清步骤，窗口太大影响填单子
 * 先暂时不弄了
 */
<template>
  <div>
    <!-- 按钮用来触发对话框显示 -->
    <button class="commonBtn btn-shadow downloadBtn step"
            @click="controlDialog">
      <span>下单<br>步骤</span>
    </button>

    <!-- 对话框组件 -->
    <div v-if="dialogVisible" class="dialog" :style="dialogPosition">
      <div class="dialog-content">
        <!-- 对话框内容 -->
        <div class="dialog-header">
          <span>下单操作步骤</span>
          <button class="close-button" @click="closeDialog">×</button>
        </div>
        <div class="dialog-body">
          这里是对话框内容
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const NAME = 'Instruction';

  export default {
    name: NAME,
    data() {
      return {
        // 控制对话框是否显示的数据属性
        dialogVisible: false,
        // 对话框的位置
        dialogPosition: {
          right: '3vw',
          top: '43vh',
        },
      };
    },
    methods: {
      // 显示对话框的方法
      controlDialog() {
        this.dialogVisible = !this.dialogVisible;
        // 更新对话框位置到按钮左侧1vw的位置
        if(this.dialogVisible) this.dialogPosition.right = `calc(3vw + 1vw + 70px)`;
      },
      // 关闭对话框的方法
      closeDialog() {
        this.dialogVisible = false;
      },
    }
  }
</script>

<style lang="scss" scoped>
  // 说明下载按钮
  .downloadBtn{
    position: fixed;
    right: 3vw;
    width: 70px;
    height: 70px;
    z-index: 999;  // 最上层
    font-weight: bold;
    color: #fff;
    opacity: 0.8;
  }
  .step{
    top: 43vh;
    background-color: $mainColor;
    &:hover{
      cursor: pointer;
      background-color: $plainBtnSelectedColor;
      opacity: 1;
    }
    span{
      font-size: 18px;
    }
  }

  /* 对话框样式 */
  .dialog {
    position: fixed;
    z-index: 1000;
    right: 3vw;
    top: 43vh;
    transition: right 0.3s ease; /* 平滑过渡 */
  }

  /* 对话框内容样式 */
  .dialog-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    width: var(--dialog-width, 300px); /* 默认宽度为300px */
    position: absolute;
    right: 0; /* 对话框距离按钮左侧1vw */
    top: 50%;
    transform: translateY(-50%);
  }

  /* 对话框标题栏样式 */
  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  /* 关闭按钮样式 */
  .close-button {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
  }

  /* 对话框主体内容样式 */
  .dialog-body {
    /* 样式根据需要自定义 */
  }
</style>



// WEBPACK FOOTER //
// src/components/common/instruction.vue